import { DOCUMENT } from "@angular/common";
import { inject, InjectionToken } from "@angular/core";

export interface WidgetScreen {
  readonly label: string;
  readonly left: number;
  readonly top: number;
  readonly width: number;
  readonly height: number;
}

export interface ScreenDetailed {
  readonly availLeft: number;
  readonly availTop: number;
  readonly availWidth: number;
  readonly availHeight: number;
  readonly label: string;
}

export interface ScreenDetails {
  readonly screens: readonly ScreenDetailed[];
}

export type ScreenDetailsSource = (() => Promise<ScreenDetails>) | undefined;

type WindowWithScreenDetails = Window & { getScreenDetails?: () => Promise<ScreenDetails> };

export const SCREEN_DETAILS_SOURCE = new InjectionToken<ScreenDetailsSource>("SCREEN_DETAILS_SOURCE", {
  providedIn: "root",
  factory: (): ScreenDetailsSource => {
    const view = inject(DOCUMENT).defaultView as WindowWithScreenDetails | null;
    const getScreenDetails = view?.getScreenDetails;
    return view && getScreenDetails ? () => getScreenDetails.call(view) : undefined;
  },
});

export function toWidgetScreen(screen: ScreenDetailed): WidgetScreen {
  return {
    label: screen.label,
    left: screen.availLeft,
    top: screen.availTop,
    width: screen.availWidth,
    height: screen.availHeight,
  };
}
